const backInTimeInfo = [
  {
    categoryName: 'D1 Schools',
    gameScores: '1950-51',
    playerAndTeamStats: '2005-06',
    notes: 'Big East player and team game stats complete back to 1996-97',
  },
  {
    categoryName: 'Poll Ranked Teams',
    gameScores: '1948-49',
    playerAndTeamStats: '2005-06',
    notes: '',
  },
  {
    categoryName: 'NCAA Tournament',
    gameScores: '1938-39 *',
    playerAndTeamStats: '1938-39 *',
    notes: 'PTS: 1938-39 REB: 1955-56 AST: 1970-71 FG: 1938-39 FGA: 1955-56 FT: 1938-39 FTA: 1938-39 FG3: 1986-87 FG3A: 1986-87 OREB: 1956-57 DREB: 1956-57 PF: 1938-39 STL: 1973-74 TO: 1973-74 BLK: 1973-74 DD: 1970-71 TD: 1970-71 Seeds: 1978-79',
  },
  {
    categoryName: 'NIT Tournament',
    gameScores: '1937-38 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'CBI Tournament',
    gameScores: '2007-08 *',
    playerAndTeamStats: '2007-08 *',
    notes: '',
  },
  {
    categoryName: 'CIT Tournament',
    gameScores: '2008-09 *',
    playerAndTeamStats: '2008-09 *',
    notes: '',
  },
  {
    categoryName: 'Basketball Classic',
    gameScores: '2021-22 *',
    playerAndTeamStats: '2021-22 *',
    notes: '',
  },
  {
    categoryName: 'The Crown',
    gameScores: '2024-25',
    playerAndTeamStats: '2024-25',
    notes: '',
  },
  {
    categoryName: 'ACC Tournament',
    gameScores: '1953-54 *',
    playerAndTeamStats: '1953-54 *',
    notes: 'PTS: 1953-54 REB: 1953-54 AST: 1953-54 FG: 1953-54 FGA: 1953-54 FT: 1953-54 FTA: 1953-54 FG3: 1982-83/1986-87 FG3A: 1982-83/1986-87 OREB: 1997-98 DREB: 1997-98 PF: 1953-54 STL: 1975 TO: 1979-80 BLK: 1975 DD: 1953-54 TD: 1953-54',
  },
  {
    categoryName: 'America East Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'A-Sun Tournament',
    gameScores: '1978-79 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'A-10 Tournament',
    gameScores: '1976 -77 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Big East Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '1979-80 *',
    notes: 'PTS: 1979-80 REB: 1979-80 AST: 1979-80 FG: 1979-80 FGA: 1979-80 FT: 1979-80 FTA: 1979-80 FG3: 1986-87 FG3A: 1986-87 OREB: 1982-83 DREB: 1982-83 PF: 1979-80 STL: 1979-80 TO: 1979-80 BLK: 1979-80 DD: 1979-80 TD: 1979-80',
  },
  {
    categoryName: 'Big Sky Tournament',
    gameScores: '1975-76 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Big South Tournament',
    gameScores: '1985-86 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Big Ten Tournament',
    gameScores: '1997-98 *',
    playerAndTeamStats: '1997-98 *',
    notes: '',
  },
  {
    categoryName: 'Big XII Tournament',
    gameScores: '1996-97 *',
    playerAndTeamStats: '1996-97 *',
    notes: '',
  },
  {
    categoryName: 'Big West Tournament',
    gameScores: '1975-76 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'CAA Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'C-USA Tournament',
    gameScores: '1995-96 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Horizon Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'MAAC Tournament',
    gameScores: '1981-82 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'MAC Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'MEAC Tournament',
    gameScores: '1971-72 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'MVC',
    gameScores: '1976-77 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Mountain West Tournament',
    gameScores: '1999-00 *',
    playerAndTeamStats: '2000-01',
    notes: '',
  },
  {
    categoryName: 'NEC',
    gameScores: '1981-82 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'OVC',
    gameScores: '1948-49 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'PAC-12 / PAC-10',
    gameScores: '1986-87 *',
    playerAndTeamStats: '1986-87 *',
    notes: '',
  },
  {
    categoryName: 'Patriot League Tournament',
    gameScores: '1990-91 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'SEC Tournament',
    gameScores: '1932-33 *',
    playerAndTeamStats: '1998-99',
    notes: '',
  },
  {
    categoryName: 'Southern Tournament',
    gameScores: '1921-22 ',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Southland Tournament',
    gameScores: '1980-81 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'SWAC Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Summit Tournament / Mid-Continent',
    gameScores: '1983-84 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Sun Belt Tournament',
    gameScores: '1976-77 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'WCC Tournament',
    gameScores: '1986-87 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'WAC Tournament',
    gameScores: '1983-84 *',
    playerAndTeamStats: '2002-03',
    notes: '',
  },
  {
    categoryName: 'Great West Tournament',
    gameScores: '2009-10 *',
    playerAndTeamStats: '2009-10 *',
    notes: '',
  },
  {
    categoryName: 'American Athletic Tournament',
    gameScores: '2013-14 *',
    playerAndTeamStats: '2013-14 *',
    notes: '',
  },
  {
    categoryName: 'Ivy Tournament',
    gameScores: '2016-17 *',
    playerAndTeamStats: '2016-17 *',
    notes: '',
  },
];

export default backInTimeInfo;







																
										
